import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=02ec6e53&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=02ec6e53&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec6e53",
  null
  
)

export default component.exports